// extracted by css-extract-rspack-plugin
export default {"DashboardBackButton":"A2t4n"};